import { ProductDetailsService } from '@product-details/services/product-details.service';
import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { GAConfirmationPageLoad } from '@analytics/classes/ga.confirmation.class';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromAnalytics from '../actions';
import { tap, withLatestFrom, switchMap, filter } from 'rxjs/operators';

@Injectable()
export class GAConfirmationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly analyticsService: AnalyticsService,
    private readonly viewOffersService: ViewOffersService,
    private readonly productDetailsService: ProductDetailsService,
    private readonly additionalServicesService: AdditionalServicesService,
    private readonly completeOrderService: CompleteOrderService
  ) {}

  PageLoad$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.ConfirmationPageLoad),
        switchMap(() =>
          this.viewOffersService.offersLoaded$.pipe(
            filter(Boolean),
            withLatestFrom(
              this.completeOrderService.upfrontPayment$,
              this.viewOffersService.offers$,
              this.productDetailsService.selected$,
              this.completeOrderService.cardPaymentRedirect$,
              this.additionalServicesService.itemOffer$,
              this.completeOrderService.createOrder$,
              this.completeOrderService.formData$
            ),
            tap(
              ([
                ,
                upfront,
                offers,
                selected,
                cardPaymentRedirect,
                itemOffer,
                order,
                form,
              ]) => {
                const gaData = new GAConfirmationPageLoad(
                  upfront,
                  offers,
                  selected,
                  cardPaymentRedirect?.response,
                  itemOffer,
                  order,
                  form
                ).gaData;

                this.analyticsService.eventEmitter(gaData);
              }
            )
          )
        )
      ),
    { dispatch: false }
  );
}
